<template>
    <div>
        <common-step-progressbar :steps="progressbarSteps" :currentStep="progressbarCurrentStep"></common-step-progressbar>

        <common-page-plain>
            <common-content-wrapper width="medium">
                <common-content-spacer height="medium">
                    <common-page-header
                        :heading="$t('pages.offer.create_offer.title')"
                        :content="$t('pages.offer.create_offer.subtitle')"
                        :isCenter="true"
                    ></common-page-header>

                    <create-offer-form :prefill="data"></create-offer-form>
                </common-content-spacer>
            </common-content-wrapper>
        </common-page-plain>
    </div>
</template>
<script>
    import CreateOfferForm from 'components/forms/offer/CreateOfferForm'
    import CurrencyEnum from 'enums/currency.enum'
    import CurrencyOptionsEnum from 'enums/currency_options.enum'

    export default {
        components: { CreateOfferForm },

        data() {
            return {
                progressbarCurrentStep: 0,
                progressbarSteps: [
                    this.$t('pages.offer.create_offer.progressbar.service_data'),
                    this.$t('pages.offer.create_offer.progressbar.category'),
                    this.$t('pages.offer.create_offer.progressbar.photos'),
                    this.$t('pages.offer.create_offer.progressbar.schedule'),
                ],
                currencyOptions: Object.values(CurrencyEnum).map((currency) => ({ label: currency, value: currency })),

                data: [],
            }
        },

        mounted() {
            this.data.currency = this.currencyOptions[CurrencyOptionsEnum.RSD].value
            if (this.$route.query.location) {
                this.data.location = {
                    id: Number(this.$route.query.location),
                    companyServiceProvider: {
                        id: this.$route.query.company ? Number(this.$route.query.company) : 0,
                    },
                }
            }
        },
    }
</script>
